<template>
	<card class="is-card-table has-pagination has-table-borderless has-bottom-left-hidden" title="テンプレート一覧" icon="format-list-bulleted">
		<b-button slot="button" type="is-success" @click="onNewButtonClick">新規作成</b-button>
		<report-template-table :data="data" :totalNum="totalNum" :isLoading="isLoading" :checkable="false" @delete-buton-click="onDeleteButtonClick"/>
	</card>
</template>

<script>
import Card from "@/components/Card";
import ReportTemplateTable from "@/components/ReportTemplateTable";
import qs from 'qs';

export default {
	name: 'report-template',
	components: {
		Card,
		ReportTemplateTable,
	},
	data() {
		return {
			data: [],
			isLoading: false,
			totalNum: 0,
			customers: [],
		}
	},
	mounted() {
		this.init();
		this.$store.commit('basic', {
			key: 'titleBarTitleStack',
			value: ['日報テンプレート管理']
		});
	},
	methods: {
		onNewButtonClick: function() {
			this.$router.push({ name: 'report-template-new' });
		},
		onSearchButtonClick: function(isHiddenContain, customerId) {
			this.getData(isHiddenContain, customerId);
		},
		init: function() {
			this.getData();
		},
		getData: async function(isHiddenContain = 0, customerId = '') {
			this.isLoading = true;
			let ep = 'report-templates';
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				if (!res.data.list) {
					this.data = [];
				} else {
					this.data = res.data.list;
				}
				this.totalNum = this.data.length;
			} catch (error) {
				this.$utils.log(error);
				this.$utils.toastError(error.response.data.message);
			} finally {
				this.isLoading = false;
			}
		},
		onDeleteButtonClick: async function(id) {
			if (!window.confirm(this.$consts.MSG_CONFIRM_DELETE)) {
				return false;
			}

			let loading = this.$loading.open();
			let ep = 'report-templates/delete';
			this.$utils.log(ep);

			try {
				let res = await this.$api.post(ep, { "id": id }, true);
				this.$utils.log(res);
				this.data.some(function(v, i){
					if (v.id === id) this.data.splice(i, 1);
				}, this);
			} catch (error) {
				this.$utils.log(error);
				this.$utils.toastError(error.response.data.message);
			} finally {
				loading.close();
			}
		},
	},
}
</script>

<style scoped>
</style>
